import { useState, useEffect } from 'react';
import { useLocation, Link, useParams, useSearchParams } from 'react-router-dom';
import { Layout, Tabs } from 'antd';
import SignUpList from './components/List';
import SignUpSetting from './components/Setting';
import SignIn from '../SignIn';
import { conferenceOnceApi } from '@services/Conference';
import './index.less';
import PageHeader from '@components/PageHeader/PageHeader';
import { CONFERENCE_WORKSPACE_PARENT_PATH, CONFERENCE_WORKSPACE_ROUTE_BASE } from '@/layouts/conferenceWorkspaceConfig';
// 报名管理
const SignUp = () => {
    const location = useLocation();

    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const conferenceId = params?.id || 0; // 会议项目 ID
    const [conference, setConference] = useState(null);

    useEffect(() => {
        if (!conferenceId) return;
        let cancelled = false;
        setConference(null);
        conferenceOnceApi({ id: conferenceId }).then(res => {
            if (cancelled) return;
            if (res.status_code === 200) {
                setConference(res.data);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [conferenceId]);

    const tabItems = [
        { label: '报名设置', key: '1', children: <SignUpSetting /> },
        { label: '报名列表', key: '2', children: <SignUpList /> },
        { label: '签到管理', key: '3', children: <SignIn /> },
    ];

    const onChange = key => {
        console.log(key);
    };

    useEffect(() => {
        document.title = '报名签到-医会议';
    }, []);

    return (
        <>
            <PageHeader title="报名签到" breadcrumb={[{ label: '医会议', path: CONFERENCE_WORKSPACE_PARENT_PATH }, { label: conference?.name || '项目信息', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}` }, '报名签到']} />

            <div className="page-route-body">
                <Tabs key={conferenceId} className="sign-up-tabs" defaultActiveKey={!!searchParams.get('type') ? searchParams.get('type') : '1'} size="large" tabBarGutter={50} onChange={onChange} items={tabItems} />
            </div>
        </>
    );
};

export default SignUp;
